'use strict';

const DiagramRepository = require('system/domain/repository/diagram');

module.exports = {
    /**
     * 渡した element(`model`) が射影されている Diagram の一覧を返す
     *
     * params.context.diagramId が指定されている場合、
     * その Diagram は除外される(現在表示中の Diagram を除外する目的)。
     *
     * params.context - Context dict
     * params.model   - Element
     */
    getProjectedDiagrams: function(params) {
        return DiagramRepository.getDiagrams({
            context: params.context
        })
            .chain()
            .filter(function(d) {
                return d.hasElement(params.model);
            }, this)
            .filter(function(d){
                return d.get('diagram_id') !=
                    params.context.diagramId;
            }, this)
            .value();
    }
};



// WEBPACK FOOTER //
// ./system/domain/service/element.js